import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APICONSTANTS } from '../../constants/api-constants';
import { BcLineModel } from '../../models/societe-linked/bc/bc-line.model';
import { LivraisonBcModel } from '../../models/societe-linked/bc/livraison-bc.model';
import { GenericCrudService } from '../basic/generic.crud.service';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class LivraisonBcService extends GenericCrudService<LivraisonBcModel> {
  observer = new BehaviorSubject<LivraisonBcModel>(null);
  public bcSubscriber = this.observer.asObservable();

  constructor(protected http: HttpClient,
              protected toastr: ToastrService,
              protected hostnameService: HostnameService) {
    super(http, toastr, APICONSTANTS.ROUTELIVRAISONBC, hostnameService);
  }

  getLivByBcligne(t: BcLineModel[]): Observable<LivraisonBcModel[]> {
    return this.http.post<LivraisonBcModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getLivByBcligne', t)
        .pipe(catchError(err => this.requestCatchError(err, 'Récupération')));
  }

}
